import Api from '../baseApi'

export default {
  async fetchAll() {
    return await Api.get(`/api-article/v1/addition`);
  },
  async fetch(id) {
    return await Api.get(`/api-article/v1/addition/${id}`);
  },
  async create(data) {
    return await Api.put('/api-article/v1/addition', data);
  },
  async update(data) {
    return await Api.post('/api-article/v1/addition', data);
  },
  async delete(id) {
    return await Api.delete(`/api-article/v1/addition/${id}`);
  },
  async copy(id) {
    return await Api.post(`/api-article/v1/addition/copy/${id}`);
  }
}
